export default {
  environment: {
    name: process.env.NODE_ENV || 'development',
    development: {
      apiUrl: 'http://localhost:3000/api'
    },
    production: {
      apiUrl: 'https://capturefit.com/api'
    }
  }
}
